import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentPipe } from '@ap/content';
import { ApSearchInputComponent } from '@ap/input/search';
import { ApListItemComponent } from '@ap/list-item';

import { MijnZoekenComponent } from './mijn-zoeken.component';
import { MijnZoekenService } from './mijn-zoeken.service';

/**
 * @ngdoc module
 * @name MijnZoekenModule
 **/
@NgModule({
    exports: [MijnZoekenComponent],
    imports: [ReactiveFormsModule, ApAnalyticsModule, ApContentPipe, ApListItemComponent, ApSearchInputComponent, CommonModule],
    declarations: [MijnZoekenComponent],
    providers: [MijnZoekenService]
})
export class MijnZoekenModule {}
